"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.brand = exports.bron = exports.Looptijd = exports.PaymentMethod = exports.IsSwitch = exports.Gender = exports.Brand = void 0;
/**
 * The brand of the hostname this request was sent to
 */
exports.Brand = {
    ENERGIEDIRECT: 'energiedirect',
    ESSENT: 'essent'
};
/**
 * The gender
 */
exports.Gender = {
    MALE: 'Male',
    FEMALE: 'Female',
    UNKNOWN: 'Unknown'
};
/**
 * Is switch
 */
exports.IsSwitch = {
    TRUE: 'true',
    FALSE: 'false'
};
/**
 * The payment method
 */
exports.PaymentMethod = {
    S: 'S',
    I: 'I',
    A: 'A'
};
/**
 * The product looptijd
 */
exports.Looptijd = {
    F: 'F',
    _1: '1',
    _2: '2',
    _3: '3',
    _5: '5'
};
exports.bron = {
    ONLINE: 'Online'
};
exports.brand = {
    ED: 'ed',
    ESSENT: 'essent'
};
